import React from "react";
import { Link } from "react-router-dom";
import { useAuth, hasPermission } from "../context/AuthContext";
import { labPageUrl } from "../lib/workflowLinks";

/**
 * Contextual links on purchase transaction detail.
 */
export default function PurchaseDetailLinks({ purchase }) {
  const { user } = useAuth();
  if (!purchase) return null;

  const items = [];

  if (hasPermission(user, "page.weighbridge")) {
    items.push({ to: "/weighbridge/inward", label: "Weighbridge" });
  }
  if (hasPermission(user, "page.gate")) {
    items.push({ to: "/gate/procurement", label: "Gate passes (inward)" });
  }
  if (hasPermission(user, "page.contracts") && purchase.purchase_contract_id) {
    items.push({
      to: "/contracts",
      label: `Contract #${purchase.purchase_contract_id}`,
      title: "Open purchase contracts list",
    });
  }
  if (hasPermission(user, "page.lab") && purchase.lab_required !== false) {
    items.push({ to: labPageUrl("truck"), label: "Truck lab" });
  }
  if (hasPermission(user, "page.unloading") && ["APPROVED", "UNLOADING", "COMPLETED"].includes(purchase.state)) {
    items.push({ to: "/unloading", label: "Unloading" });
  }
  if (hasPermission(user, "page.accounts") && (purchase.state === "ACCOUNTS_PENDING" || purchase.voucher)) {
    const voucherId = purchase.voucher?.id
      || (purchase.vouchers || []).find((v) => v.voucher_type === "MATERIAL")?.id;
    items.push({
      to: voucherId ? `/accounts?voucher=${voucherId}` : "/accounts",
      label: purchase.state === "ACCOUNTS_PENDING" ? "Accounts review" : "Open voucher",
    });
  }

  if (!items.length) return null;

  return (
    <div className="flex flex-wrap gap-2 text-xs" data-testid="purchase-detail-links">
      {items.map((item) => (
        <Link
          key={item.to + item.label}
          to={item.to}
          title={item.title}
          className="inline-flex items-center px-2.5 py-1 rounded-md border border-border bg-card text-primary hover:bg-accent/80 font-medium"
        >
          {item.label} →
        </Link>
      ))}
    </div>
  );
}
